'use strict';

module.exports = !('0' in Object('a'));